import "./styles.scss";

const CenteredLoader = ({ show, customStyles=null }) => {
  return show ? (
    <div className="loader-overlay" style={customStyles}>
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </div>
  ) : null;
};

export default CenteredLoader;
